import type { GraphQLError } from 'graphql';

import { expValEquals } from '@confluence/feature-experiments';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import BylinePageAdfQuery, {
	type BylinePageAdfQuery$data,
	type BylinePageAdfQuery$variables,
} from './queries/__generated__/BylinePageAdfQuery.graphql.ts';

export async function preloadBylinePageAdf({
	contentId,
	useCache,
}: {
	contentId: BylinePageAdfQuery$variables['contentId'];
	useCache: boolean;
}): Promise<
	| {
			data: BylinePageAdfQuery$data | null;
			errors?: ReadonlyArray<GraphQLError>;
			hasErrors: boolean;
	  }
	| undefined
> {
	if (
		!contentId ||
		!expValEquals('confluence_1p_and_3p_connection_byline_experiment', 'isEnabled', true)
	) {
		return;
	}

	return query<BylinePageAdfQuery$data, BylinePageAdfQuery$variables>({
		query: BylinePageAdfQuery,
		variables: { contentId },
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
